import DesktopSearch from './DesktopSearch.vue'

const searchComponents = [DesktopSearch]

export default searchComponents
